// extracted by mini-css-extract-plugin
module.exports = {"hidden":"styles_hidden__g4hxQ","desktop":"styles_desktop__cX7qV","mobile":"styles_mobile__to5NM","tablet":"styles_tablet__bP2zR","responsive":"styles_responsive__UhczB"};